import actionTypes from './actions/actiontypes'

const {
  REQUEST_CONTACT_LIST,
  RECEIVE_CONTACT_LIST,
  SERVER_ERROR_OCURED,
  REQUEST_LIST_DETAILS,
  RECEIVE_LIST_DETAILS
} = actionTypes

const contactsReducer = (state = {
  isFetchingList: false,
  isFetchingListDetails: false,
  contacts: [],
  list: [],
  hasServerError: false
}, action) => {
  switch (action.type) {
    case REQUEST_CONTACT_LIST:
      return Object.assign({}, state, {
        isFetchingList: true
      })
    case RECEIVE_CONTACT_LIST:
      return Object.assign({}, state, {
        isFetchingList: false,
        contacts: action.contacts
      })
    case REQUEST_LIST_DETAILS:
      return Object.assign({}, state, {
        isFetchingListDetails: true
      })
    case RECEIVE_LIST_DETAILS:
      return Object.assign({}, state, {
        isFetchingListDetails: false,
        list: action.list
      })
    case SERVER_ERROR_OCURED:
      return Object.assign({}, state, {
        hasServerError: true
      })
    default:
      return state
  }
}

export default contactsReducer



// WEBPACK FOOTER //
// ./src/routes/Contacts/reducer.js